<template>
  <b-col sm="12" lg="8">
    <div class="animated fadeIn">
      <b-card class="backClass">
        <Toasts></Toasts>
        <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <h4>User Info</h4>
          <span class="title-details">
            <b>Full Name:</b>
            {{name}}
          </span>
          <span class="title-details">
            <b>Email:</b>
            {{email}}
          </span>
          <span class="title-details">
            <b>Company:</b>
            {{company}}
          </span>
          <span class="title-details">
            <b>Title:</b>
            {{title}}
          </span>
          <hr />
          <b-row>
            <b-col sm="12" lg="12">
              <h4>Change Password</h4>
            </b-col>
            <b-col sm="12" lg="4">
              <input
                type="text"
                ref="newPw"
                class="form-control"
                id="inputPassword"
                autocomplete="nope"
                value=""
                placeholder="Enter new password..."
              />
            </b-col>
            <b-col sm="12" lg="4">
              <input
                type="text"
                ref="newPwC"
                class="form-control"
                autocomplete="nope"
                value=""
                id="inputPassword1"
                placeholder="Confirm new password..."
              />
            </b-col>
            <b-col sm="12" lg="4">
              <b-button
                class="uploadPic"
                variant="outline-primary"
                @click="changePassword()"
              >Change Password</b-button>
            </b-col>
          </b-row>

        </div>
      </b-card>
    </div>
  </b-col>
</template>


<script>
import { Switch as cSwitch } from "@coreui/vue";
import router from '../router'

export default {
  name: "ProfilePicture",
  components: {
    cSwitch,
    router
  },
  props: ["productsData", "userData"],
  data() {
    return {
      loadingData: true,
      userId: null,
      dataRdy: 0,
      company: "",
      email: "",
      name: "",
      title: "",
      selectedProducts: [],
      financeVisible: true,
      products: [{"name":"Line Gear","checked":false},{"name":"Fiber Gear","checked":false},{"name":"Power Supply","checked":true},{"name":"Transponder","checked":false},{"name":"Meter","checked":false},{"name":"Headend","checked":false}],
      labelTxt: {
        dataOn: "yes",
        dataOff: "no"
      }
    };
  },

  methods: {
    changePassword() {
      let newPassword = this.$refs.newPw.value;
      let newConfirm = this.$refs.newPwC.value;

      if (newPassword == newConfirm && newPassword != "") {
        this.$refs.newPwC.style.border = "";

        let formData = new FormData();
        formData.append("userId", this.userId);
        formData.append("new_pass", newPassword);
        formData.append("confirm_pass", newConfirm);

        this.$http
          .post(
            process.env.VUE_APP_TRACKER_URL + "api/har/profile/changePassword.php",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          )
          .then(
            res => {
              this.data = res.data.records;
              console.log(res.data);
              localStorage.clear();
              router.push("/pages/login/");
            },
            err => {
              console.log(err);
            }
          );
      } else {
        this.$refs.newPwC.style.border = "1px solid red";
      }
    },
    valueChange(param) {
      if (this.dataRdy == 6) {
      let checked;
      if(param.checked == true) {
        param.checked = false;
        console.log(param);
        checked = 0
      } else {
        param.checked = true;
         console.log(param);
        checked = 1
      }
     let formData = new FormData();
        formData.append("userId", this.userId);
        formData.append("group", param.name.replace(/\s+/g, '').toLowerCase());
        formData.append("val", checked);
      } else {
        this.dataRdy++;
        console.log(this.dataRdy);
      }

    }
  },
  mounted() {
    this.userId = localStorage.getItem("har_user");
    this.name = this.userData.name;
    this.title = this.userData.title;
    this.email = this.userData.email;
    this.company = this.userData.company;
    //this.products = this.productsData;
    this.loadingData = false;
    console.log(this.dataRdy);
  }
};
</script>

<style scoped>
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}

.switch-label.switch-lg {
  display: block;
  margin: auto;
}
.productLabels {
  display: block;
  text-align: center;
  padding: 5px;
}
.card-body {
  min-height: 480px !important;
}
</style>
